import { action, payload } from 'ts-action'
import { IPayStub } from 'models/PayStub'
import { IError, IPayload } from 'models/Global'

export const PayStubsFetching = action('PayStubsFetching', payload<boolean>())

export const GetPayStubs = action(
  'GetPayStubs',
  payload<IPayload<IPayStub[]>>(),
)

export const GetPayStubsErrors = action('GetPayStubsErrors', payload<IError>())
